export const countdown = (function ($) {

    // Reference: https://codepen.io/chrisjdesigner/pen/dMbmoE

    let currentDate,
        days,
        hrs,
        min,
        sec;

    function serverTime() {

        // using random number versioning to avoid cache on page load
        let randomInt = Math.floor(Math.random() * 100000);
        let dateTimePhp = window.ENV.siteUrl + "/datetime.json.php?v=" + randomInt;

        // Get the current date
        $.ajax({
            url: dateTimePhp,
            type: 'GET',
            dataType: 'json', // added data type
            success: function(res) {
                currentDate = Date.parse(res.datetime.replace(/ /g,"T")); // SAFARI bug: replacing the space with "T" or else the browser don't recognize it correctly

                // // Calculate time until launch date
                timeToLaunch();
            },
            async: false // using as synchronous request to manage initial number animation
        });

    }

    function timeToLaunch() {

        currentDate += 1000; // remove 1000 milliseconds from parsed date

        let calcDiff = (currentDate - countDownDate)/1000;
        let diff = Math.abs(Math.floor(calcDiff));

        if (calcDiff < 0) {
            // Check number of days until target
            days = Math.floor(diff/(24*60*60));
            sec = diff - days * 24*60*60;

            // Check number of hours until target
            hrs = Math.floor(sec/(60*60));
            sec = sec - hrs * 60*60;

            // Check number of minutes until target
            min = Math.floor(sec/(60));
            sec = sec - min * 60;

        } else {
            days = 0;
            hrs = 0;
            min = 0;
            sec = 0;
        }


    }

    function countDownTimer() {
        // // Recalculate time
        timeToLaunch();

        // Write to countdown component
        $( "#js-countdown-days .countdown__number" ).text(days);
        $( "#js-countdown-hours .countdown__number" ).text(hrs);
        $( "#js-countdown-minutes .countdown__number" ).text(min);
        $( "#js-countdown-seconds .countdown__number" ).text(sec);

        // Repeat the check every second
        setTimeout(countDownTimer,1000);
    }

    function numberTransition(id, endPoint, transitionDuration, transitionEase){
        // Transition numbers from 0 to the final number
        $({numberCount: $(id).text()}).animate({
            numberCount: endPoint
        }, {
            duration: transitionDuration,
            easing:transitionEase,
            step: function() {
                $(id).text(Math.floor(this.numberCount));
            },
            complete: function() {
                $(id).text(this.numberCount);
            }
        });
    }

    function init() {
        if ($("#js-countdown")) {
            // // Get serverTime from PHP file
            serverTime();

            // // Transition the current countdown from 0
            numberTransition('#js-countdown-days .countdown__number', days, 2000, 'swing');
            numberTransition('#js-countdown-hours .countdown__number', hrs, 2000, 'swing');
            numberTransition('#js-countdown-minutes .countdown__number', min, 2000, 'swing');
            numberTransition('#js-countdown-seconds .countdown__number', sec, 2000, 'swing');

            // // Begin Countdown
            setTimeout(countDownTimer,2001);
        }
    }

    return {
        init: init
    }

})(jQuery);